module.exports = __webpack_public_path__ + "img/landingpage-video-desktop-people.b3cd4e06.svg";